jQuery(document).ready(function ($) {
    if ($(window).width() < 768) {
        $("#shopify-section-template--15099959771221__main-product .product-form__input.product-form__input--color.product-form__input--color--large").each(function () {
            // Wrap the product input inside a new div
            $(this).wrap('<div class="product-form-wrapper"></div>');

            // Add Prev button before the wrapper
            $('<div class="prev-button-container"><button class="scroll-prev">&lt;</button></div>').insertBefore($(this).parent());

            // Add Next button after the wrapper
            $('<div class="next-button-container"><button class="scroll-next">&gt;</button></div>').insertAfter($(this).parent());
        });

        // Scroll functionality (adjust if needed)
        var scrollAmount = 180;

        $(".scroll-prev").click(function () {
            $("fieldset.product-form__input.product-form__input--color.product-form__input--color--large").parent()[0].scrollBy({ left: -scrollAmount, behavior: "smooth" });
        });

        $(".scroll-next").click(function () {
            $("fieldset.product-form__input.product-form__input--color.product-form__input--color--large").parent()[0].scrollBy({ left: scrollAmount, behavior: "smooth" });
        });
    }
});
